import type { RelatedTypeEnum } from '../../../enums'

import type { AnalyticsState, MutationClass } from '../../../models'

import Vue from 'vue'

export class SetRelatedDataMutation implements MutationClass {
  static execute(
    this: void,
    state: AnalyticsState,
    payload: { data: any; selectedId: string; relatedType: RelatedTypeEnum },
  ): void {
    const selectedIdData = state.data.ids[payload.selectedId]
    if (!selectedIdData) {
      Vue.set(state.data.ids, payload.selectedId, {
        dist: {
          currentPeriod: undefined,
        },
        pivots: {},
        related: {
          [payload.relatedType]: payload.data,
        },
      })
    } else {
      if (!selectedIdData.related[payload.relatedType]) {
        Vue.set(selectedIdData.related, payload.relatedType, payload.data)
      } else {
        selectedIdData.related[payload.relatedType] = payload.data
      }
    }
  }
}
